export default __webpack_public_path__ + "static/media/code_button.94dee1d7.png";